import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "addressInput",
    "latitudeInput",
    "longitudeInput",
    "mapContainer"
  ]

  connect() {
    // Inicializar mapa si hay coordenadas
    if (this.hasLatitudeInputTarget && this.hasLongitudeInputTarget) {
      const lat = parseFloat(this.latitudeInputTarget.value)
      const lng = parseFloat(this.longitudeInputTarget.value)

      if (lat && lng) {
        this.initializeMap(lat, lng)
      }
    }
  }

  searchAddress(event) {
    const address = event.target.value

    if (address.length > 5) {
      // Usar la API de geocodificación de Google
      this.geocodeAddress(address)
    }
  }

  getCurrentLocation(event) {
    event.preventDefault()

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude
          const lng = position.coords.longitude

          // Actualizar campos ocultos
          this.latitudeInputTarget.value = lat
          this.longitudeInputTarget.value = lng

          // Inicializar mapa
          this.initializeMap(lat, lng)

          // Geocodificar inversamente para obtener la dirección
          this.reverseGeocode(lat, lng)
        },
        (error) => {
          console.error('Error obteniendo ubicación:', error)
          alert('No se pudo obtener tu ubicación actual. Por favor, ingresa la dirección manualmente.')
        }
      )
    } else {
      alert('Tu navegador no soporta geolocalización.')
    }
  }

  geocodeAddress(address) {
    // Usar la API de Google Geocoding
    const apiKey = this.getGoogleApiKey()
    if (!apiKey) {
      console.warn('No se encontró la API key de Google')
      return
    }

    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.results && data.results.length > 0) {
          const location = data.results[0].geometry.location
          const lat = location.lat
          const lng = location.lng

          // Actualizar campos ocultos
          this.latitudeInputTarget.value = lat
          this.longitudeInputTarget.value = lng

          // Inicializar mapa
          this.initializeMap(lat, lng)
        }
      })
      .catch(error => {
        console.error('Error en geocodificación:', error)
      })
  }

  reverseGeocode(lat, lng) {
    const apiKey = this.getGoogleApiKey()
    if (!apiKey) {
      console.warn('No se encontró la API key de Google')
      return
    }

    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.results && data.results.length > 0) {
          const address = data.results[0].formatted_address
          this.addressInputTarget.value = address
        }
      })
      .catch(error => {
        console.error('Error en geocodificación inversa:', error)
      })
  }

  initializeMap(lat, lng) {
    if (!this.hasMapContainerTarget) return

    this.mapContainerTarget.style.display = 'block'

    // Verificar si Google Maps ya está cargado
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
      this.loadGoogleMapsAPI().then(() => {
        this.createMap(lat, lng)
      })
    } else {
      this.createMap(lat, lng)
    }
  }

  createMap(lat, lng) {
    const mapElement = document.getElementById('map')
    if (!mapElement) return

    const map = new google.maps.Map(mapElement, {
      center: { lat: lat, lng: lng },
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    })

    // Agregar marcador
    new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: map,
      title: 'Ubicación de la consulta'
    })
  }

  loadGoogleMapsAPI() {
    return new Promise((resolve, reject) => {
      const apiKey = this.getGoogleApiKey()
      if (!apiKey) {
        reject('No se encontró la API key de Google')
        return
      }

      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
      script.async = true
      script.defer = true

      script.onload = resolve
      script.onerror = reject

      document.head.appendChild(script)
    })
  }

  getGoogleApiKey() {
    // Buscar la API key en el meta tag o en una variable global
    const metaTag = document.querySelector('meta[name="google-maps-api-key"]')
    if (metaTag) {
      return metaTag.getAttribute('content')
    }

    // Fallback a variable global
    if (window.GOOGLE_MAPS_API_KEY) {
      return window.GOOGLE_MAPS_API_KEY
    }

    return null
  }
}
